"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Comment = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 13,
  height: 12,
  viewBox: "0 0 13 12"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M6.81 0C3.396 0 .619 2.692.619 6c0 1.157.335 2.261.974 3.224L0 12h6.81C10.223 12 13 9.308 13 6s-2.777-6-6.19-6",
  className: "fill"
}));

var _default = Comment;
exports.default = _default;